// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1Ynmk","row":"Node_row__3ZGPC","label":"Node_label__1D3Rn","footer":"Node_footer__2LVHm"};